<template>
	<div id="service8">
		<Menu areWeinServices="true" selectedRoute="consulting"/>
		<div class="colorAzul">
			<section class="secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
				<div class="fondotransparenteServicio">
					<h1>{{title}}</h1>
				</div>
			</section>

			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">Security is our expertise. We can provide you with an extra pair of eyes, and an independent informed analysis, in order to help you marshall the resources of your company and improve the security of your facilities in Mexico.</h2> 
						<p class="parrafoContenidoInterno">Companies are subject to a number of risks, threats and vulnerabilities to your internal and external security.
							<span>Glarus Group</span> Security Audits and services include:
						</p>

						<ul class="listaContenidoInterno">
							<li>Detection of potential threats and vulnerabilities</li>
							<li>Risk Reduction Recommendations and Workplan</li>
							<li>Measures to meet the security and safety standards dictated by building regulations</li>
							<li>Implementation of corrective measures</li>
							<li>Staffing of Security Positions</li>
						</ul>
						<p class="parrafoContenidoInterno">
							At <span>Glarus Group</span> we believe that security is more than the sum of perimeter walls, security personnel, access cards, cameras and sensors,etc. Instead, we believe that security is a matter of fostering a culture of mindfulness and risk prevention within your organization. We can help you foster this culture.
						</p>
					</div>

					<cuadro/>

					<!-- cuadro -->
				</div>
			</section>

			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>{{titleIcons}}</span>
					</h1>

					<div class="gridIcons" :class="{spaceBetWeen: precautions.length >2}">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/8/image1.jpg";
import imagen2 from "@/assets/img/servicios/8/second_.jpg";
import icono01 from "@/assets/img/servicios/8/01.png";
import icono02 from "@/assets/img/servicios/8/02.png";
import icono03 from "@/assets/img/servicios/8/03.png";
import icono04 from "@/assets/img/servicios/8/04.png";

export default {
	name: "servicio08",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title = "Glarus Group - Risk Analysis and Consulting in Mexico";
		});
	},
	data: function() {
		return {
			title: "RISK ANALYSIS AND CONSULTING IN MEXICO",
			// subtitle: "Consultancy on risks",
			// thirdTitle: "Security is a matter of attitude.",
			firstImage: imagen1,
			secondImage: imagen2,
			titleIcons: "We Provide",

			precautions: [
				{
					id: "4",
					icon: icono04,
					altIcon: "glarus service 8",
					descripcion: "Security Audits, Risk Analysis and Workplans"
				},
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 8",
					descripcion: "Consulting around Perimeter Security, and Technology"
				},
				{
					id: "3",
					icon: icono03,
					altIcon: "glarus service 8",
					descripcion:
						"Immediate response and investigation of intrusion or theft incidents"
				},
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 8",
					descripcion: "Compliance with local and federal Civil Protection regulations"
				}
			]
		};
	}
};
</script>




<style lang="less">
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
